module.exports = __webpack_public_path__ + "0331fe22366611e71917ca225289bea6.svg";